import React from 'react';
import * as XLSX from 'xlsx';

const TableDownloadCard = ({ tableData, index }) => {
    const downloadAsExcel = () => {
        const { columns, data } = tableData.content.data;
        const wsData = [columns, ...data];
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(wsData);
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        const safeFilename = tableData.title
            ? `${tableData.title.replace(/[^a-z0-9]/gi, '_').toLowerCase()}.xlsx`
            : `table_data_${index}.xlsx`;

        XLSX.writeFile(wb, safeFilename);
    };

    const downloadAsCSV = () => {
        const { columns, data } = tableData.content.data;
        const csvContent = [
            columns.join(','),
            ...data.map(row => row.map(cell =>
                typeof cell === 'string' && (cell.includes(',') || cell.includes('"'))
                    ? `"${cell.replace(/"/g, '""')}"`
                    : cell
            ).join(','))
        ].join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        const safeFilename = tableData.title
            ? `${tableData.title.replace(/[^a-z0-9]/gi, '_').toLowerCase()}.csv`
            : `table_data_${index}.csv`;

        link.setAttribute('href', url);
        link.setAttribute('download', safeFilename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const files = [
        { type: 'XLS', label: '.XLS file' },
        { type: 'CSV', label: '.CSV file' }
    ];

    const handleDownload = (fileType) => {
        if (fileType === 'XLS') {
            downloadAsExcel();
        } else if (fileType === 'CSV') {
            downloadAsCSV();
        }
    };

    const FileIcon = () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M16.0341 22.0417C16.0341 22.5951 15.5855 23.0437 15.0321 23.0437L7.01625 23.0437C5.68839 23.0437 4.4444 22.3898 3.55228 21.4977C2.66017 20.6056 2.00633 19.3616 2.00633 18.0338C2.00633 17.0272 2.00476 16.0206 2.00319 15.013C2.00162 14.0057 2.00004 12.9975 2.00004 11.9892C2.00004 10.5068 2.00162 9.51229 2.00319 8.63806L2.00364 8.38506C2.00505 7.61445 2.00633 6.9131 2.00633 6.00995C2.00633 4.68208 2.66017 3.43809 3.55228 2.54598C4.44439 1.65387 5.68839 1.00002 7.01625 1.00002V3.00399C6.34014 3.00399 5.58017 3.35213 4.9693 3.963C4.35844 4.57386 4.0103 5.33384 4.0103 6.00995C4.0103 6.91472 4.00902 7.61765 4.00761 8.38791C4.00746 8.47158 4.00731 8.55605 4.00715 8.64166C4.00558 9.51524 4.00401 10.5084 4.00401 11.9892C4.00401 12.9957 4.00558 14.0023 4.00715 15.0099C4.00872 16.0172 4.0103 17.0254 4.0103 18.0338C4.0103 18.7099 4.35844 19.4699 4.9693 20.0807C5.58016 20.6916 6.34014 21.0397 7.01625 21.0397L15.0321 21.0397C15.5855 21.0397 16.0341 21.4883 16.0341 22.0417ZM7.01625 3.00399H16.0339C17.568 3.00399 19.0393 4.13844 19.0399 6.01025C19.0403 7.50113 19.0399 8.03658 19.0396 8.58254C19.0393 8.95438 19.0391 9.3311 19.0391 10.0179C19.0391 10.5713 19.4877 11.0199 20.0411 11.0199C20.5945 11.0199 21.0431 10.5713 21.0431 10.0179C21.0431 9.33458 21.0433 8.95791 21.0436 8.58564C21.0439 8.03806 21.0443 7.50002 21.0438 6.00964C21.0429 2.87153 18.5077 1.00002 16.0339 1.00002H7.01625V3.00399Z" fill="#303C54" />
            <path fillRule="evenodd" clipRule="evenodd" d="M7.00993 2.00198C7.00993 1.4486 7.45853 1 8.01191 1L16.0278 1.00001C17.3556 1.00001 18.5996 1.65384 19.4918 2.54595C20.3839 3.43806 21.0377 4.68205 21.0377 6.00993C21.0377 7.01645 21.0393 8.0231 21.0408 9.03066C21.0424 10.038 21.044 11.0462 21.044 12.0545C21.044 13.5369 21.0424 14.5314 21.0408 15.4056L21.0404 15.6586C21.039 16.4292 21.0377 17.1306 21.0377 18.0337C21.0377 19.3616 20.3839 20.6056 19.4918 21.4977C18.5996 22.3898 17.3556 23.0437 16.0278 23.0437V21.0397C16.7039 21.0397 17.4639 20.6916 18.0747 20.0807C18.6856 19.4698 19.0337 18.7099 19.0337 18.0337C19.0337 17.129 19.035 16.426 19.0364 15.6558C19.0366 15.5721 19.0367 15.4876 19.0369 15.402C19.0385 14.5284 19.04 13.5353 19.04 12.0545C19.04 11.048 19.0385 10.0413 19.0369 9.03378C19.0353 8.02648 19.0337 7.01827 19.0337 6.00992C19.0337 5.33381 18.6856 4.57383 18.0747 3.96298C17.4639 3.35212 16.7039 3.00398 16.0278 3.00398L8.01191 3.00397C7.45853 3.00397 7.00993 2.55537 7.00993 2.00198ZM16.0278 21.0397L7.01013 21.0397C5.47601 21.0397 4.00475 19.9052 4.00418 18.0334C4.00373 16.5426 4.00408 16.0071 4.00445 15.4612C4.00469 15.0893 4.00494 14.7126 4.00494 14.0258C4.00494 13.4724 3.55634 13.0238 3.00296 13.0238C2.44957 13.0238 2.00097 13.4724 2.00097 14.0258C2.00097 14.7091 2.00072 15.0858 2.00048 15.458C2.00012 16.0056 1.99976 16.5437 2.00021 18.034C2.00116 21.1722 4.53632 23.0437 7.01013 23.0437L16.0278 23.0437V21.0397Z" fill="#303C54" />
            <path fillRule="evenodd" clipRule="evenodd" d="M3.00296 13.0238C2.44957 13.0238 2.00005 12.5752 2.00005 12.0219C2.00005 10.8869 2.36348 9.86268 3.10614 9.12001C3.84881 8.37735 4.87303 8.01392 6.00798 8.01392H7.51096C8.03475 8.01392 8.39338 7.84369 8.61855 7.61853C8.84371 7.39336 9.01394 7.03473 9.01394 6.51094V5.00796C9.01394 3.87301 9.37737 2.84878 10.12 2.10612C10.8627 1.36345 11.8869 1.00002 13.0219 1.00002C13.5753 1.00002 14.0239 1.44863 14.0239 2.00201C14.0239 2.55539 13.5753 3.00399 13.0219 3.00399C12.3159 3.00399 11.8371 3.22307 11.5371 3.52314C11.237 3.82321 11.0179 4.30196 11.0179 5.00796V6.51094C11.0179 7.49013 10.6871 8.38398 10.0356 9.03555C9.384 9.68711 8.49015 10.0179 7.51096 10.0179H6.00798C5.30199 10.0179 4.82324 10.237 4.52316 10.537C4.22309 10.8371 4.00401 11.3159 4.00401 12.0219C4.00401 12.5752 3.55634 13.0238 3.00296 13.0238Z" fill="#303C54" />
        </svg>
    );

    return (tableData &&
        <>
            <div className="bg-gray-50 mb-5">
                <style>{`
                        .title-text {
                        font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
                        font-weight: 700;
                        font-size: 16px;
                        line-height: 22px;
                        letter-spacing: 0%;
                        color: #4C4C66;
                        }
                        
                        .file-label-text {
                        font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
                        font-weight: 400;
                        font-size: 16px;
                        line-height: 22px;
                        letter-spacing: 0%;
                        color: #4C4C66;
                        }
                        
                        .download-text {
                        font-family: 'Noto Sans', sans-serif;
                        font-weight: 700;
                        font-size: 14px;
                        line-height: 20px;
                        letter-spacing: 0%;
                        text-decoration: underline solid;
                        vertical-align: middle;
                        }
                `}</style>
                <div className="max-w-[100%]">
                    <div className="bg-white p-6 rounded-lg shadow-md" style={{ boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
                        <h1 className="title-text mb-6">
                            {tableData.title || 'Download your data'}
                        </h1>

                        <div className="space-y-3">
                            {files.map((file) => (
                                <div
                                    key={file.type}
                                    className="flex items-center gap-3"
                                >
                                    <FileIcon />

                                    <span className="file-label-text mr-2">
                                        {file.label}
                                    </span>

                                    <button
                                        onClick={() => handleDownload(file.type)}
                                        className="download-text text-blue-600 hover:text-blue-800"
                                    >
                                        Download
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div></>
    );
};

export default TableDownloadCard;